import { render } from "./SaleDetailsView.vue?vue&type=template&id=249e3931"
import script from "./SaleDetailsView.vue?vue&type=script&lang=js"
export * from "./SaleDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__